import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { mediaUrl } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { usePlayer } from "../context/PlayerContext";
import { fmtDate } from "../lib/utils2";
import { Crown, Heart, History, Play, User } from "lucide-react";

export default function Account() {
  const { user } = useAuth();
  const { play } = usePlayer();
  const [tab, setTab] = useState("favorites");
  const [favorites, setFavorites] = useState([]);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    api.get("/me/favorites").then((r) => setFavorites(r.data));
    api.get("/me/history").then((r) => setHistory(r.data));
  }, []);

  if (!user) return null;

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex items-center gap-4 mb-10">
        <div className="w-16 h-16 rounded-2xl bg-navy flex items-center justify-center overflow-hidden">
          {user.picture ? <img src={user.picture} alt="" className="w-full h-full object-cover" /> : <User className="w-8 h-8 text-gold" />}
        </div>
        <div>
          <h1 className="font-serif text-3xl font-bold text-navy">{user.name}</h1>
          <p className="text-slate-500">{user.email}</p>
        </div>
      </div>

      {/* Subscription card */}
      <div className={`rounded-2xl p-6 mb-10 ${user.is_subscribed ? "bg-gradient-to-r from-navy to-petrol text-white" : "bg-white border border-slate-200"}`}>
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-3">
            <Crown className={`w-8 h-8 ${user.is_subscribed ? "text-gold" : "text-slate-300"}`} />
            <div>
              <div className={`font-semibold ${user.is_subscribed ? "text-white" : "text-navy"}`}>{user.is_subscribed ? `Abbonamento ${user.subscription?.plan} attivo` : "Nessun abbonamento attivo"}</div>
              <div className={`text-sm ${user.is_subscribed ? "text-slate-300" : "text-slate-400"}`}>
                {user.is_subscribed ? `Rinnovo il ${fmtDate(user.subscription?.expires_at)}` : "Abbonati per i contenuti premium"}
              </div>
            </div>
          </div>
          {!user.is_subscribed && <Link to="/abbonamenti" data-testid="account-subscribe" className="bg-navy text-white rounded-full px-6 py-2.5 font-medium hover:bg-petrol">Abbonati</Link>}
        </div>
      </div>

      <div className="flex gap-2 border-b border-slate-200 mb-8">
        <button onClick={() => setTab("favorites")} data-testid="tab-favorites" className={`flex items-center gap-2 px-5 py-3 font-medium border-b-2 -mb-px transition-colors ${tab === "favorites" ? "border-navy text-navy" : "border-transparent text-slate-400"}`}><Heart className="w-4 h-4" /> Preferiti</button>
        <button onClick={() => setTab("history")} data-testid="tab-history" className={`flex items-center gap-2 px-5 py-3 font-medium border-b-2 -mb-px transition-colors ${tab === "history" ? "border-navy text-navy" : "border-transparent text-slate-400"}`}><History className="w-4 h-4" /> Cronologia</button>
      </div>

      {tab === "favorites" && (
        favorites.length === 0 ? <p className="text-slate-400 py-12 text-center">Nessun episodio nei preferiti.</p> :
        <div className="space-y-3">
          {favorites.map((ep) => <Row key={ep.id} ep={ep} play={play} />)}
        </div>
      )}
      {tab === "history" && (
        history.length === 0 ? <p className="text-slate-400 py-12 text-center">Nessun ascolto recente.</p> :
        <div className="space-y-3">
          {history.map((h, i) => h.episode && <Row key={`${h.episode.id}-${h.at}`} ep={h.episode} play={play} sub={fmtDate(h.at)} />)}
        </div>
      )}
    </div>
  );
}

const Row = ({ ep, play, sub }) => (
  <div className="flex items-center gap-4 bg-white border border-slate-100 rounded-xl p-3 hover:shadow-md transition-shadow">
    <img src={mediaUrl(ep.cover_url)} alt="" className="w-14 h-14 rounded-lg object-cover" />
    <div className="flex-1 min-w-0">
      <Link to={`/episodi/${ep.id}`} className="font-semibold text-navy hover:text-gold truncate block">{ep.title}</Link>
      <div className="text-sm text-slate-400">{sub || ep.category}</div>
    </div>
    <button onClick={() => play(ep)} className="w-10 h-10 rounded-full bg-navy text-white flex items-center justify-center hover:bg-petrol shrink-0"><Play className="w-4 h-4 ml-0.5" /></button>
  </div>
);
